var map = {
	"./AndroidLogo.svg": 64775,
	"./download.svg": 15253,
	"./iosLogo.svg": 92453,
	"./jiantou.svg": 88029,
	"./jiantou1.svg": 44118,
	"./liebiao.svg": 78874,
	"./validCode.svg": 28538,
	"./圈.svg": 11739,
	"./大于.svg": 80114,
	"./小上箭头.svg": 59665,
	"./小下箭头.svg": 23900,
	"./小右箭头.svg": 22116
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;